module.exports = __webpack_public_path__ + "media/images/mail-bottom-d305638a7338601aa6a8886bbf940d83.png";